/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import systems.frictionless.impulse.browser.style.AppStyleSheet
import systems.frictionless.impulse.rest.client.model.Progress
import kotlin.math.min

@Composable
@Suppress("MagicNumber")
fun ProgressView(progress: Progress) {
    Div(attrs = {
        classes(AppStyleSheet.progressOuter)
    }) {
        Div(attrs = {
            classes(AppStyleSheet.progressInner)
            style {
                val percent = min(100, (progress.toPercent().decimal * 100).toInt() + 1)
                width(
                    percent.percent
                )
            }
        }) { }
    }
}
